/** `sections/impact-report-values.liquid` — `<impact-report-values>`: switches
 *  between value panels via the dotted-line nav and a sticky nav that appears
 *  once the main nav scrolls out of view.
 */

class ImpactReportValues extends HTMLElement {
  #abort
  #nav
  #stickyNav
  #navItems
  #stickyNavItems
  #panels
  #observer

  connectedCallback() {
    this.#nav = this.querySelector('[data-nav]')
    this.#stickyNav = this.querySelector('[data-sticky-nav]')
    this.#navItems = this.querySelectorAll('.impact-report-values-nav-item')
    this.#stickyNavItems = this.querySelectorAll('.impact-report-values-sticky-nav-item')
    this.#panels = this.querySelectorAll('.impact-report-values-panel')

    this.#abort = new AbortController()
    this.#bindNav(this.#navItems)
    this.#bindNav(this.#stickyNavItems)
    this.#setupStickyNav()
  }

  disconnectedCallback() {
    this.#abort?.abort()
    this.#observer?.disconnect()
  }

  #bindNav(items) {
    items.forEach((item) => {
      item.addEventListener(
        'click',
        () => this.#setActive(item.dataset.index),
        { signal: this.#abort.signal }
      )
    })
  }

  #setActive(index) {
    this.#navItems.forEach((item) => {
      item.classList.toggle('active', item.dataset.index === index)
    })
    this.#stickyNavItems.forEach((item) => {
      item.classList.toggle('active', item.dataset.index === index)
    })
    this.#panels.forEach((panel) => {
      panel.classList.toggle('active', panel.dataset.index === index)
    })
  }

  #setupStickyNav() {
    if (!this.#nav || !this.#stickyNav) return

    this.#observer = new IntersectionObserver(
      ([entry]) => {
        this.classList.toggle('show-sticky-nav', !entry.isIntersecting)
      },
      { threshold: 0, rootMargin: '-80px 0px 0px 0px' }
    )

    this.#observer.observe(this.#nav)
  }
}

if (!customElements.get('impact-report-values')) {
  customElements.define('impact-report-values', ImpactReportValues)
}
